import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ChatMessage } from '../../../models/chat-message';
import { EnumType } from '../../../models/enums/enum';
@Component({
	selector: 'app-chat-message-list-options',
	templateUrl: './chat-message-list-options.component.html',
	styleUrls: ['./chat-message-list-options.component.scss']
})
export class ChatMessageListOptionsComponent implements OnInit {

	@Input() index: number;
	@Input() elements: any;
	@Output() onOptionMessageClicked: EventEmitter<any> = new EventEmitter<any>();

	constructor() { }

	ngOnInit() { }

	addMessage(item: any) {
		let element: ChatMessage = {
			senderName: EnumType.MessageSender.USER,
			time: new Date(),
			payload: {
				type: 'text',
				values: item.text,
				intent: item.intent
			}
		};
		this.onOptionMessageClicked.emit(element);
	}

	openUrl(link: string) {
		let url: string = '';
		if (!/^http[s]?:\/\//.test(link)) {
			url += 'http://';
		}
		url += link;
		window.open(url, "_blank");
	}

}
